import { ReactElement } from 'react';

import { Practitioner } from '@dreryk/egabinet-waitlist-frontend-api';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

import { StyledPractitionerCell } from './PractitionerCell.styled';

type PractitionerCellProps = {
   important: boolean;
   practitioner: Practitioner;
};

export const PractitionerCell = (props: PractitionerCellProps): ReactElement => {
   return (
      <StyledPractitionerCell $important={props.important} alignItems={'center'} width={'100%'}>
         <PractitionerSafePresenter
            practitioner={props.practitioner}
            testId={'specialist'}
            presentationOrder={'lastName'}
            type={'standalone'}
            withIdentification
         />
      </StyledPractitionerCell>
   );
};
